import { SaveDailyReportPhotoForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { useParams } from 'react-router-dom';

export type SaveDailyReportPhotoModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveDailyReportPhotoModalProps) => {
  const params = useParams();
  const dailyReportId = params.dailyReportId;
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save Photos'
      subTitle=''
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveDailyReportPhotoForm.FC
        id=''
        dailyReportId={dailyReportId ?? ''}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
